export const SECTOR_ALREADY_EXIST = "Sector already exists";
export const SECTOR_LENGTH_ERROR = "Sector can not exceed 4 characters";
export const SELECT_RESTRICTION_FOR_EACH_SECTOR =
  "Please select a restriction for each sector";

export const SERVICE_RESTRICTED_FIELD = "serviceRestricted";
export const RESTRICTION_2DAY = "2 Day";
